<template>
  <div>
    <div class="search-box">
      <div class="search-box-inner">
        <input
          type="text"
          placeholder="店舗名、住所の一部を入力"
          v-model="word"
          @keydown.down="onKeyDown()"
          @keydown.up="onKeyUp()"
          @keydown.enter="onEnter()"
          @focus="onFocus()"
          @change="onChange()"
        />
        <img v-if="0 === word.length" src="@/assets/images/ico-search.svg" />
        <a v-else href="#" @click.prevent="word = ''">
          <img src="@/assets/images/close.svg" />
        </a>
      </div>
      <div v-if="0 < filtered.length" class="list-container">
        <ul>
          <!-- 
            switching from p.item to p['item'] 
            because typescript is throwing type errors when using dot notation. 

            You can switch back to dot notation when you types the data properly
          -->
          <li
            v-for="p of filtered"
            :key="p['code']"
            @click="selectPlace(p)"
            @mouseover="setFocus(p)"
            @mouseleave="unsetFocus(p)"
            :class="{ 'is-focused': isFocused(p) }"
          >
            <span class="genre" :class="genreClass(p['genre'])"></span>
            <span class="name-address">
              <span class="name">{{ p['name'] }}</span>
              <span class="address">{{ p['address'] }}</span>
            </span>
            <span class="status" :class="statusClass(p['status'])">{{
              statusSearchLabel(p['status'])
            }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="isNotFound" class="not-found">
      <p>キーワードに合致する結果が⾒つかりませんでした。</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import mixin from './Search.mixin.js';

export default defineComponent({
  name: 'SearchPC',
  mixins: [mixin]
});
</script>

<style scoped lang="scss">
.search-box {
  width: 480px;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  background-color: #fff;

  &-inner {
    display: flex;
    padding: 12px 12px 13px 20px;

    input {
      flex-grow: 1;
      font-size: 14px;
      line-height: 20px;
      height: 20px;
      color: #000;
      border: none;
      outline: none;
      padding: 0;
    }

    img {
      width: 20px;
      height: 20px;
    }

    a {
      display: block;
      width: 20px;
      height: 20px;

      img {
        padding: 2px;
        width: 16px;
        height: 16px;
      }
    }
  }

  .list-container {
    padding: 10px;
    border-top: 1px solid #eeeeee;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    max-height: 350px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }

    li {
      cursor: pointer;
      padding: 0 6px;
      display: flex;
      align-items: center;
      height: 35px;

      &.is-focused {
        background-color: #f5f5f5;
      }

      span {
        white-space: nowrap;
        overflow: hidden;
      }

      .genre {
        flex-shrink: 0;
        display: block;
        width: 24px;
        height: 24px;
        background-size: cover;

        &.is-supermarket {
          background-image: url('@/assets/images/ico24-market.svg');
        }
        &.is-homecenter {
          background-image: url('@/assets/images/ico24-homecenter.svg');
        }
        &.is-drugstore {
          background-image: url('@/assets/images/ico24-drag.svg');
        }
        &.is-discountshop {
          background-image: url('@/assets/images/ico24-discount.svg');
        }
        &.is-departmall {
          background-image: url('@/assets/images/ico24-mall.svg');
        }
      }

      .name-address {
        font-size: 11px;
        text-overflow: ellipsis;
        color: #666666;

        .name {
          margin-left: 6px;
          color: #000;
          font-weight: bold;
          font-size: 13px;
        }

        .address {
          margin-left: 6px;
          color: #666666;
          font-size: 11px;
        }
      }

      .status {
        width: 40px;
        height: 20px;
        flex-shrink: 0;
        margin-left: 6px;
        border-radius: 2px;
        color: #fff;
        font-size: 11px;
        font-weight: bold;
        text-align: center;
        line-height: 20px;

        &.is-status-0 {
          background-color: #fff;
          color: #999999;
          border: 1px solid #cccccc;
          box-sizing: border-box;
          line-height: 18px;
        }
        &.is-status-1 {
          background-color: #4ab2f2;
        }
        &.is-status-2 {
          background-color: #9db41d;
        }
        &.is-status-3 {
          background-color: #d61a1a;
        }
      }
    }
  }
}

.not-found {
  color: #d61a1a;
  font-size: 11px;
  font-weight: bold;
  padding-left: 20px;
}
</style>
